import {useEffect} from "react";
import {useFormContext} from "react-hook-form";

import {PhoneListField} from "@/components/form/fields/PhoneListField.tsx";
import {ServerErrors} from "@/lib/types/common.ts";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {SetupInfo} from "@/pages/integrations/edit/subForms/components/SetupInfo.tsx";

export type FormValuesKey = keyof IntegrationFormData;

interface WhatsAppFormProps {
  serverErrors?: ServerErrors;
}

export const WhatsAppForm = ({serverErrors}: WhatsAppFormProps) => {
  const {setError} = useFormContext();

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors)
        .filter((key) => key !== "__all__")
        .forEach((key) => setError(`settings.${key}` as FormValuesKey, {message: serverErrors[key][0]}));
    }
  }, [setError, serverErrors]);

  return (
    <>
      <div className="row row-cols-2 mb-3">
        <div className="col-12 mb-3">
          <PhoneListField
            name="settings.phone_numbers"
            label="Recipients"
            required={true}
            tooltip="WhatsApp phone numbers in international format (example: +14155551234)."
          />
        </div>
      </div>
      <SetupInfo>
        <div className="p-2">
          Each message uses one SMS credit. Every recipient needs a WhatsApp account: use Test and confirm the message
          arrives.
        </div>
      </SetupInfo>
    </>
  );
};
